const mediaQuery = globalThis.matchMedia('(max-width: 800px)');
const isMobileBreakpoint = mediaQuery.matches;

// validates if the URL is a local URL
function isLocalUrl(urlToCheck) {
  const clientPath = SITEBASEURL;
  return urlToCheck !== null && urlToCheck.includes(clientPath);
}

// set the "Buy Now" link as the default link for the card
function setBuyNowDefault(card, url) {
  card.attr('href', url);
  card.removeClass('void-link');
  const targetUrl = isLocalUrl(url) ? '_self' : '_blank';
  card.attr('target', targetUrl);
}

// validate links for the card widget
function validateLinks(data, x, item) {
  const { URL, PurchaseURL } = data.items[x];
  const hasValidLink = PurchaseURL || URL;
  const onlyPurchase = PurchaseURL && !URL;

  // if the card doesn't have any link remove the atributes and add the class
  if (!hasValidLink) {
    item.removeAttr('href');
    item.removeAttr('target');

    return;
  }

  // when the card only have the purchase link is set as the default link on mobile
  if (onlyPurchase && isMobileBreakpoint) {
    setBuyNowDefault(item, PurchaseURL);
  }
}

function modifyLinkBehavior(widgetData, cards) {
  cards.each(function (x) {
    const card = $(this);
    const cardIsLink = card.is('a');
    const buttons = card.find('.buttonwrap');
    const cardHasButton = buttons.children().length > 0;

    switch (true) {
      case cardIsLink:
        validateLinks(widgetData, x, card);
        if (isMobileBreakpoint) {
          // remove the buttonwrap when is mobile
          buttons.remove();
        }
        break;
      case cardHasButton:
        validateLinks(widgetData, x, card);
        break;

      default:
        if (!isMobileBreakpoint) {
          card.addClass('void-link');
        }
        break;
    }
  });
}

export { modifyLinkBehavior, isMobileBreakpoint, isLocalUrl };
